import { Card, Divider, Flex, Form, Input, Select } from "antd";
import { useForm } from "antd/es/form/Form";
import CardSectionTitle from "components/CardSectionTitle.component";
import { translate } from "shared/languages";
import { Business } from "shared/types";
import { BusinessType } from "shared/types/enum";
import PhoneInput, { phoneRules } from "shared/components/PhoneInput";

const { Option } = Select;

interface BusinessProfileCardProps {
  business: Business;
}

const BusinessProfileCard = ({ business }: BusinessProfileCardProps) => {
  const [businessForm] = useForm();

  return (
    <Card>
      <Flex vertical gap={20}>
        <CardSectionTitle
          title={translate(`title.business_profile`)}
          subtitle={translate(`subtitle.business_profile`)}
        />
        <Form
          form={businessForm}
          name="business-profile"
          labelAlign="left"
          labelCol={{ span: 6 }}
          colon={false}
          requiredMark={false}
          initialValues={{
            name: business.name,
            email: business.email,
            phone_number: business.phone_number,
            address: business.address,
            business_type: business.business_type,
            legal_name: business.legal_name,
            npwp: business.npwp,
          }}
          disabled
        >
          <Form.Item
            name="name"
            label={translate("label.name")}
            rules={[{ required: true, message: "Please input your name!" }]}
          >
            <Input />
          </Form.Item>
          {/* Read-only, same as every other field here — only a System Admin
              can set/change it (Bisnis > Profil Bisnis), but a Manager/Admin
              should still be able to see their own business's data. */}
          <Form.Item name="legal_name" label={translate("label.legal_name")}>
            <Input placeholder="PT ..." />
          </Form.Item>
          {/* No placeholder: read-only anyway, and a full 16-digit example
              would read as clutter rather than guidance. */}
          <Form.Item name="npwp" label={translate("label.npwp")}>
            <Input />
          </Form.Item>
          <Divider />
          <Form.Item
            name="email"
            label="Email"
            rules={[{ type: "email", message: translate("form.error.email") }]}
          >
            <Input
              placeholder={`${translate("form.placeholders.enter")} email`}
            />
          </Form.Item>
          <Form.Item
            name="phone_number"
            label={translate("label.phone_number")}
            rules={phoneRules()}
          >
            <PhoneInput
              placeholder={`${translate("form.placeholders.enter")} ${translate(
                "form.placeholders.phone_number"
              )}`}
              disabled
            />
          </Form.Item>
          <Divider />
          <Form.Item
            name="address"
            label={translate("label.address")}
            rules={[{ required: true, message: "Please input your address!" }]}
          >
            <Input.TextArea placeholder="Enter business address" />
          </Form.Item>

          <Form.Item
            name="business_type"
            label={translate("label.business_type")}
            rules={[
              { required: true, message: "Please select your business type!" },
            ]}
          >
            <Select placeholder="Select business type">
              {Object.keys(BusinessType).map((business_type) => {
                return (
                  <Option key={business_type} value={business_type}>
                    {business_type.toUpperCase()}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
        </Form>
      </Flex>
    </Card>
  );
};

export default BusinessProfileCard;
